const unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#x27;': "'",
  '&#x60;': '`',
};

function createEscaper(map: Record<string, string>) {
  function escaper(match: string) {
    return map[match];
  }
  const source = '(?:' + Object.keys(map).join('|') + ')';
  const testRegexp = RegExp(source);
  const replaceRegexp = RegExp(source, 'g');

  return function (string: string) {
    string = string === null ? '' : '' + string;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}

export const unEscaper = createEscaper(unescapeMap);
